import { render, staticRenderFns } from "./DataProtectionView.vue?vue&type=template&id=02b84950"
import script from "./DataProtectionView.vue?vue&type=script&lang=js"
export * from "./DataProtectionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports